import React from "react";
import MuiDialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/styles";
import "./ConfirmDialog.css";

const Dialog = withStyles({
  paper: {
    maxWidth: 460,
    minWidth: 320,
    borderRadius: 14,
  },
})(MuiDialog);

// Generic confirmation dialog reused for the coaching and refund confirmations.
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Onayla",
  cancelLabel = "Vazgeç",
  tone = "primary", // "primary" | "danger"
  onConfirm,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="confirm-dialog">
        {title && <h3 className="confirm-dialog-title">{title}</h3>}
        {message && <p className="confirm-dialog-message">{message}</p>}
        <div className="confirm-dialog-actions">
          <button
            type="button"
            className="credit-btn credit-btn-secondary"
            onClick={onClose}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`credit-btn ${
              tone === "danger" ? "credit-btn-danger-solid" : "credit-btn-primary"
            }`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
